/* tslint:disable */
/* eslint-disable */
/**
 * Animare Management API
 * This API provides methods for viewing and modifying animare database data for authorities. 
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  DeleteMicrochipRequestDto,
  ErrorDto,
  MicrochipDto,
  MicrochipNumberChangeRequestDto,
} from '../models';
import {
    DeleteMicrochipRequestDtoFromJSON,
    DeleteMicrochipRequestDtoToJSON,
    ErrorDtoFromJSON,
    ErrorDtoToJSON,
    MicrochipDtoFromJSON,
    MicrochipDtoToJSON,
    MicrochipNumberChangeRequestDtoFromJSON,
    MicrochipNumberChangeRequestDtoToJSON,
} from '../models';

export interface ChangeMicrochipNumberRequest {
    uid: string;
    microchipNumberChangeRequestDto?: MicrochipNumberChangeRequestDto;
}

export interface DeleteMicrochipRequest {
    uid: string;
    deleteMicrochipRequestDto?: DeleteMicrochipRequestDto;
}

/**
 * 
 */
export class MicrochipRestControllerApi extends runtime.BaseAPI {

    /**
     * Changes microchip code. 
     */
    async changeMicrochipNumberRaw(requestParameters: ChangeMicrochipNumberRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MicrochipDto>> {
        if (requestParameters.uid === null || requestParameters.uid === undefined) {
            throw new runtime.RequiredError('uid','Required parameter requestParameters.uid was null or undefined when calling changeMicrochipNumber.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/microchip/{uid}/change-microchip-number`.replace(`{${"uid"}}`, encodeURIComponent(String(requestParameters.uid))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MicrochipNumberChangeRequestDtoToJSON(requestParameters.microchipNumberChangeRequestDto),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MicrochipDtoFromJSON(jsonValue));
    }

    /**
     * Changes microchip code. 
     */
    async changeMicrochipNumber(requestParameters: ChangeMicrochipNumberRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MicrochipDto> {
        const response = await this.changeMicrochipNumberRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Deletes microchip. 
     */
    async deleteMicrochipRaw(requestParameters: DeleteMicrochipRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.uid === null || requestParameters.uid === undefined) {
            throw new runtime.RequiredError('uid','Required parameter requestParameters.uid was null or undefined when calling deleteMicrochip.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/microchip/{uid}`.replace(`{${"uid"}}`, encodeURIComponent(String(requestParameters.uid))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: DeleteMicrochipRequestDtoToJSON(requestParameters.deleteMicrochipRequestDto),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deletes microchip. 
     */
    async deleteMicrochip(requestParameters: DeleteMicrochipRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteMicrochipRaw(requestParameters, initOverrides);
    }

}
